module.exports = __webpack_public_path__ + "fonts/Inter-100-greek-ext24.2d64d8a.woff2";